import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {players} from "models/players-model"; // Importing players model
import {devConfig} from "config/config"; // Importing development configuration

export default class PlayersView extends JetView {
	/**
	 * Configures the layout of the PlayersView.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service
		const theme = this.app.config.theme; // Current theme
		const screen = this.app.config.size; // Screen size configuration

		return {
			rows:[
				{
					view:"toolbar", css:theme, // Toolbar with specified theme
					elements:[
						{ view:"label", label:_("Jugadores"), localId:"label" }, // Label for players
						{ width:4 }, // Spacer
						{
							view:"text", localId:"search", hidden:true, // Search input field
							on:{
								/**
								 * Event handler for timed key press in the search input.
								 */
								onTimedKeyPress(){
									this.$scope.$$("list").clearAll(); // Clear the list before searching
									const input = this.getValue().toLowerCase(); // Get the input value in lowercase
									var vthis = this; // Reference to the current context

									if(input===""){ // If input is empty
										webix.ajax().headers({
												"Content-type": "application/json" // Set content type for AJAX request
										}).post(devConfig.geturlApi()+"es/Client/GetClients", '' , {
												error: function (text, data, XmlHttpRequest) {
														webix.message(("Error")); // Show error message
												},
												success: function (text, data, XmlHttpRequest) {
														var users = JSON.parse(text); // Parse response text to JSON
														vthis.$scope.$$("list").parse(users.Data.Objects); // Populate list with users
												}
										});
									}else{ // If there is input
										this.$scope.$$("list").load(devConfig.geturlApi()+"es/Client/GetClientById?id="+input); // Load specific client by ID
									}
								}
							}
						},
						{
							view:"icon", icon:"mdi mdi-magnify", // Search icon
							state:"closed", localId:"search_icon", // Icon state and local ID
							click:function(){
								if (this.config.state === "closed"){ // If the search is closed
									this.$scope.$$("label").hide(); // Hide label
									this.$scope.$$("search").show(); // Show search input
									this.$scope.$$("search").focus(); // Focus on search input
									this.config.state = "open"; // Update state to open
								}
								else if (this.config.state === "open"){ // If the search is open
									this.$scope.$$("label").show(); // Show label
									this.$scope.$$("search").hide(); // Hide search input
									this.config.state = "closed"; // Update state to closed
								}
							}
						}
					]
				},
				{
					view:"list", // List view for displaying players
					localId:"list", // Local ID for the list
					css:"persons_list", // CSS class for styling
					width:(screen !== "small") ? 1250 : 1230, // Set width based on screen size
					select:true, // Enable selection
					tooltip:{
						template:_("Click twice to see more goodies") // Tooltip for list items
					},
					type:{
						template:obj => // Template for list item rendering
						`<div class="text">
								<span>${obj.Id} ${obj.Login}</span> // Display player ID and login
								<span class="money">$${obj.Balance}</span> // Display player balance
						</div>`,
						height:66 // Height of each list item
					},
					on:{
						/**
						 * Event handler for after an item is selected.
						 * @param {String} id - The ID of the selected item.
						 */
						onAfterSelect:id => {
							this.app.callEvent("player:select",[Id]); // Trigger player select event
						},
						/**
						 * Event handler for double-clicking an item.
						 * @param {String} id - The ID of the double-clicked item.
						 */
						onItemDblClick:id => {
							if (this.getUrl()[0].page !== "customers") // Check current page
								this.show("customers?user="+id+"/information"); // Show customer information
							else this.show("information"); // Show general information
						}
					}
				}
			]
		};
	}

	/**
	 * Initializes the PlayersView.
	 */
	init(){
		const _ = this.app.getService("locale")._; // Localization service
		const list = this.$$("list"); // Reference to the list

		webix.ajax().headers({
				"Content-type": "application/json" // Set content type for AJAX request
		}).post(devConfig.geturlApi()+"es/Client/GetClients", '' , {
				error: function (text, data, XmlHttpRequest) {
						webix.message(("Error")); // Show error message
				},
				success: function (text, data, XmlHttpRequest) {
						var users = JSON.parse(text); // Parse response text to JSON
						list.parse(users.Data.Objects); // Populate list with users
				}
		});

		players.waitData.then(() => { // Wait for players data to be ready
			if (this.getUrl()[1].page !== "customers"){ // Check if not on customers page
				const cur_user = this.getParam("user",true); // Get current user ID
				list.select(cur_user); // Select current user in the list
				list.showItem(cur_user); // Show current user item
			}
		});

		this.on(this.app,"customer:save",(data) => { // Event handler for saving customer data
			const id = data.id || this.getParam("user",true); // Get ID from data or current user
			players.updateItem(id,data); // Update player data
			webix.message(_("Saved")); // Show saved message
		});

		this.on(this.app,"form:update",(id) => { // Event handler for updating form data
			players.waitData.then(() => { // Wait for players data to be ready
				const user = list.getSelectedId(); // Get selected user ID
				if (!user){ // If no user is selected
					list.select(id || 1); // Select the provided ID or default to 1
					list.showItem(id || 1); // Show the selected item
				}
				else {
					this.app.callEvent("customer:updatedata",[list.getItem(user)]); // Trigger update event with selected user data
				}
			});
		});

		this.on(this.app,"taction:select",record => { // Event handler for selecting a record
			if (record) { // If a record is provided
				const person = players.find(obj => obj.company === record.id)[0]; // Find the corresponding player
				if (person){ // If player is found
					list.select(person.id); // Select the player in the list
					list.showItem(person.id); // Show the player item
				}
			}
			else
				list.unselect(); // Unselect if no record is provided
		});

		this.on(this.app,"payment:history:ready",() => players.waitData.then(() => list.select(1))); // Select the first item when payment history is ready
	}
}

// FILE DOCUMENTED
